// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"86":"auth-module","601":"catalog-module","625":"gaming-module","683":"notices-module","723":"core-module","837":"account-module"}[chunkId] + "." + {"86":"2d1f0881","601":"e10a93eb","625":"277a8f73","683":"d2bb76f7","723":"0b275ad8","837":"de286ec1"}[chunkId] + ".css";
};